const MOODBOARD_PRODUCT_COUNTERS = [
  document.getElementById("moodboard_product_count"),
  document.getElementById("moodboard_product_count_mobile"),
];
const MOODBOARD_MODIFY_PRODUCTS_FUNCTION = function (
  event,
  productID,
  method,
  classToHide,
  reload
) {
  event.preventDefault();

  fetch(`/mijn-favorieten/${productID}`, { method: method })
    .then((response) => response.json())
    .then((response) =>
      Array.from(MOODBOARD_PRODUCT_COUNTERS).forEach(
        (element) => (element.innerText = response.moodboard_products || 0)
      )
    )
    .then(function () {
      if (reload) {
        location.reload();
        return;
      }

      document
        .querySelectorAll(`[data-product-id=\"${productID}\"]`)
        .forEach(function (element) {
          const classToShow =
            classToHide === "moodboard_remove_product"
              ? "moodboard_add_product"
              : "moodboard_remove_product";

          if (element.classList.contains(classToHide)) {
            element.classList.add("hidden");
          }
          if (element.classList.contains(classToShow)) {
            element.classList.remove("hidden");
          }
          if (classToShow === "moodboard_remove_product" && element.classList.contains("moodboard_goto_favourites")) {
              element.classList.remove("hidden");
          }
        });
    });
};

const MOODBOARD_ADD_PRODUCT_BUTTONS = document.getElementsByClassName(
  "moodboard_add_product"
);
const MOODBOARD_REMOVE_PRODUCT_BUTTONS = document.getElementsByClassName(
  "moodboard_remove_product"
);
const MOODBOARD_UPDATE_PRODUCT_INPUTS = document.getElementsByClassName(
  "moodboard_update_product"
);

Array.from(MOODBOARD_ADD_PRODUCT_BUTTONS).forEach((element) =>
  element.addEventListener("click", function (event) {
    const productID = this.getAttribute("data-product-id");
    const reload = this.getAttribute("data-reload") === "true";
    MOODBOARD_MODIFY_PRODUCTS_FUNCTION(
      event,
      productID,
      "POST",
      "moodboard_add_product",
      reload
    );
  })
);

Array.from(MOODBOARD_REMOVE_PRODUCT_BUTTONS).forEach((element) =>
  element.addEventListener("click", function (event) {
    const productID = this.getAttribute("data-product-id");
    const reload = this.getAttribute("data-reload") === "true";
    MOODBOARD_MODIFY_PRODUCTS_FUNCTION(
      event,
      productID,
      "DELETE",
      "moodboard_remove_product",
      reload
    );
  })
);

Array.from(MOODBOARD_UPDATE_PRODUCT_INPUTS).forEach((element) =>
  element.addEventListener("input", function (event) {
    const productID = this.getAttribute("data-product-id");
    if (element.value === '0') {
        MOODBOARD_MODIFY_PRODUCTS_FUNCTION(
            event,
            productID,
            "DELETE",
            "moodboard_remove_product",
            true
        );
        return;
    }
    fetch(`/mijn-favorieten/${productID}`, {
      method: "PUT",
      body: JSON.stringify({ quantity: element.value }),
    });
  })
);

const MOODBOARD_MODIFY_SERVICES_FUNCTION = function (
    event,
    serviceID,
    method,
    classToHide,
    reload
) {
    event.preventDefault();

    fetch(`/mijn-favorieten/dienst/${serviceID}`, { method: method })
        .then((response) => response.json())
        .then((response) =>
            Array.from(MOODBOARD_PRODUCT_COUNTERS).forEach(
                (element) => (element.innerText = response.moodboard_products || 0)
            )
        )
        .then(function () {
            if (reload) {
                location.reload();
                return;
            }

            document
                .querySelectorAll(`[data-service-id=\"${serviceID}\"]`)
                .forEach(function (element) {
                    const classToShow =
                        classToHide === "moodboard_remove_service"
                            ? "moodboard_add_service"
                            : "moodboard_remove_service";

                    if (element.classList.contains(classToHide)) {
                        element.classList.add("hidden");
                    }
                    if (element.classList.contains(classToShow)) {
                        element.classList.remove("hidden");
                    }
                });
        });
};

const MOODBOARD_ADD_SERVICE_BUTTONS = document.getElementsByClassName(
    "moodboard_add_service"
);
const MOODBOARD_REMOVE_SERVICE_BUTTONS = document.getElementsByClassName(
    "moodboard_remove_service"
);
const MOODBOARD_UPDATE_SERVICE_INPUTS = document.getElementsByClassName(
    "moodboard_update_service"
);

Array.from(MOODBOARD_ADD_SERVICE_BUTTONS).forEach((element) =>
    element.addEventListener("click", function (event) {
        const serviceID = this.getAttribute("data-service-id");
        const reload = this.getAttribute("data-reload") === "true";
        MOODBOARD_MODIFY_SERVICES_FUNCTION(
            event,
            serviceID,
            "POST",
            "moodboard_add_service",
            reload
        );
    })
);

Array.from(MOODBOARD_REMOVE_SERVICE_BUTTONS).forEach((element) =>
    element.addEventListener("click", function (event) {
        const serviceID = this.getAttribute("data-service-id");
        const reload = this.getAttribute("data-reload") === "true";
        MOODBOARD_MODIFY_SERVICES_FUNCTION(
            event,
            serviceID,
            "DELETE",
            "moodboard_remove_service",
            reload
        );
    })
);

Array.from(MOODBOARD_UPDATE_SERVICE_INPUTS).forEach((element) =>
    element.addEventListener("input", function (event) {
        const serviceID = this.getAttribute("data-service-id");
        fetch(`/mijn-favorieten/${serviceID}`, {
            method: "PUT",
            body: JSON.stringify({ quantity: element.value }),
        });
    })
);

Array.from(document.querySelectorAll('#quote-add-product-button')).forEach((element) => {
    element.addEventListener('click', function (event) {
        document.querySelector('#menu-open').click();
        event.preventDefault();
    })
})